/** @format */
import { rgba } from 'emotion-rgba/dist';
import { css } from 'styled-components';

import {
    largeDesktop,
    largeTablet,
    mobile,
    safeObjectFit,
    smallMobile,
    smallTablet,
} from '@toucan/client/global/application';

const offsetAnimationHeight = 10;
const transitionStyle = 'transition: 600ms ease-out';

const baseStyles = () => css`
    color: var(--colors-text-inverse);

    .container {
        position: relative;
        overflow: hidden;
        border-radius: 1.6rem;
        margin-bottom: var(--layout-spacing-16);

        img {
            ${safeObjectFit('cover')};
            ${transitionStyle};
        }

        &:hover .overlay-container {
            &:before {
                top: 0;
            }
            .overlay-content {
                visibility: visible;
                opacity: 1;
                bottom: 0;
            }

            & ~ .preview-title {
                display: none;
            }
        }

        &:hover img {
            transform: scale(1.05);
        }

        &:hover ~ .preview-title {
            opacity: 0;
            top: -${offsetAnimationHeight}px;
        }
    }

    .preview-title {
        ${transitionStyle};
        position: relative;
        top: 0;
    }

    .overlay-container {
        height: 100%;
        position: absolute;
        top: 0;

        .overlay-content {
            display: flex;
            height: 100%;
            position: relative;
            flex-direction: column;
            justify-content: flex-end;
            padding: var(--layout-spacing-24);
            visibility: hidden;
            opacity: 0;
            ${transitionStyle};
            bottom: -${offsetAnimationHeight}px;
        }

        &:before {
            content: '';
            ${transitionStyle};
            position: absolute;
            top: 100%;
            left: 0;
            bottom: 0;
            right: 0;
            background: linear-gradient(
                180deg,
                ${rgba('#0b002b', 0)} 0%,
                ${rgba('#0b002b', 0.8)} 41.87%,
                var(--colors-surface-inverse) 86.98%
            );
        }

        p {
            margin-bottom: var(--layout-spacing-24);
        }
    }

    .skeleton-card {
        margin-bottom: var(--layout-spacing-16);
        overflow: hidden;
    }

    .skeleton-title {
        max-width: 13rem;
        overflow: hidden;
    }
`;
const sizeStyles = () => css`
    .container,
    .skeleton-card {
        padding-bottom: 85%;

        ${largeDesktop(
            css`
                padding-bottom: 158%;
            `
        )}
        ${largeTablet(
            css`
                padding-bottom: 114%;
            `
        )}
        ${smallTablet(
            css`
                padding-bottom: 82%;
            `
        )}
        ${mobile(
            css`
                padding-bottom: 95%;
            `
        )}
        ${smallMobile(
            css`
                padding-bottom: 128%;
            `
        )}
    }
`;

export const styles = () => css`
    ${baseStyles()}
    ${sizeStyles()}
`;
